const sorting = [-1, 1]

export default (array, sortedProperty, sort = 'asc') => array.sort((element, compare) => {
  const elementProperty = element[sortedProperty]
  const compareProperty = compare[sortedProperty]

  if (elementProperty < compareProperty) {
    return sort === 'asc' ? sorting[0] : sorting[1]
  } else if (elementProperty > compareProperty) {
    return sort === 'asc' ? sorting[1] : sorting[0]
  }

  return 0
})



// WEBPACK FOOTER //
// ./src/utils/sort.js